import Cookies from 'universal-cookie';

const AUTH_TOKEN_COOKIE = `js_auth_token`;

const AUTH_HEADER = `auth-token`;

const LOGOUT_PATH = '/user/logout';

const TRANSACTION_HEADER = 'transaction-id';

const SYSTEM_COOKIE = 'g4_syskey';

const SYSTEM_HEADER = 'g4-sys-key';

const LOGIN_PATH = '/?destination=my-profile#user-login';

const onLogout = () => {
  const cookies = new Cookies(document && document.cookie);
  cookies.remove(AUTH_TOKEN_COOKIE);
  window.location.replace('/');
};

const redirectToLogin = () => {
  window.location.replace(LOGIN_PATH);
};

const authErrorRegex = /Authentication needed/g;

const isUnauthenticated = ({ message, locations, path }) => {
  return authErrorRegex.test(message);
};

const extractTokens = () => {
  const cookies = new Cookies(document && document.cookie);
  const authToken = cookies.get(AUTH_TOKEN_COOKIE);
  const transactionId = cookies.get(TRANSACTION_HEADER);
  const systemKey = cookies.get(SYSTEM_COOKIE);
  return {
    authToken,
    transactionId,
    systemKey,
  };
};

export {
  AUTH_TOKEN_COOKIE,
  AUTH_HEADER,
  LOGOUT_PATH,
  TRANSACTION_HEADER,
  SYSTEM_COOKIE,
  SYSTEM_HEADER,
  onLogout,
  isUnauthenticated,
  redirectToLogin,
  extractTokens,
};
